import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ConnectionService } from '../../connection.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-srprofile',
  templateUrl: './srprofile.component.html',
  styleUrls: ['./srprofile.component.css']
})
export class SrprofileComponent implements OnInit {
  id: any;
  freezeHashInfo: any;
  timeString: string = '';
  freezeTime: number;
  unfreezeHashInfo: any;
  unfreezeTime: number;
  constructor(private viewportScroller: ViewportScroller, private route: Router, private actRoute: ActivatedRoute, private conn: ConnectionService, private alert: ToastrService,private activatedRoute: ActivatedRoute) { 
    this.id = this.activatedRoute.snapshot.params['txid']
    setTimeout(() => {
      this.calculateTimeRemaining()
    }, 3000)
  }

  ngOnInit() {
	this.getTransaction();
  this.getUnfreezeTransaction()
  }

  getTransaction(){
    this.conn.postUrl('vote/getFreezeTransaction',{txid : this.id }).subscribe((res:any)=>
    {
      if(res.success == true){
        this.freezeHashInfo = res.data
        this.freezeTime = new Date(this.freezeHashInfo?.created_at).getTime()
      }
    })
  }

  getUnfreezeTransaction(){
    this.conn.postUrl('vote/getunFreezeTransaction',{txid : this.id }).subscribe((res:any)=>
    {
      if(res.success == true){
        this.unfreezeHashInfo = res.data
        this.unfreezeTime = new Date(this.unfreezeHashInfo?.created_at).getTime()
      }
    })
  }

  calculateTimeRemaining() {
    const currentTime = new Date().getTime();
    if(this.freezeTime){
      const timeDifference = currentTime - this.freezeTime ;
      if (timeDifference > 0) {
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        setTimeout(() => {
          this.calculateTimeRemaining();
        }, 1000);
      } else {
        // this.timeString = 'Timer expired!';
      }
    }
    else{
      const timeDifference = currentTime - this.unfreezeTime ;
      if (timeDifference > 0) {
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        setTimeout(() => {
          this.calculateTimeRemaining();
        }, 1000);
      } else {
        // this.timeString = 'Timer expired!';
      }
    }
   
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }


}
